<template>
  <react-button 
    v-bind:isReacted="statement.meta.isIgnored" 
    v-bind:name="'Ignore'" 
    v-bind:icon="'times-circle'"
    @toggleOn="ignoreStatement(); $emit('react')" 
    @toggleOff="unignoreStatement(); $emit('react')"
  />
</template>

<script>
  import Vue from "vue";
  import IgnoreButton from "./IgnoreButton.ts";

  export default IgnoreButton;
</script>
